'use client';

import React, { InputHTMLAttributes } from 'react';

import { Input } from '../../../ui/input';

// Assuming Input is in @ui/components/input

export type LocationSearchInputProps = InputHTMLAttributes<HTMLInputElement> & {
  ref?: React.Ref<HTMLInputElement>;
};

export const LocationSearchInput = ({ className, ref, ...props }: LocationSearchInputProps) => {
  return (
    <div className="relative">
      <Input
        ref={ref}
        type="text"
        className={`w-full px-3 py-2 border border-neutral-200 rounded-lg bg-white hover:border-neutral-300 transition-colors ${className || ''}`}
        {...props}
      />
    </div>
  );
};

LocationSearchInput.displayName = 'LocationSearchInput';
